// eslint-disable-next-line no-unused-vars
import { ILanguage } from './ILanguage';

export default {
  title: 'Nosso time',
  text: `Mais de cem prêmios Nobel foram concedidos a alemães brilhantes por realizações em física, medicina, química,
  literatura e outras áreas. Isso sem contar os prêmios concedidos a pessoas dos outros dois principais países de
  língua alemã, Áustria e Suíça. Além disso, muitos dos destinatários de outras nações receberam seu treinamento nas
  universidades alemãs. Portanto, se você deseja adicionar um Prêmio Nobel ao seu currículo, aprender alemão pode não
  ser um bom ponto de partida. Talvez você tenha objetivos um pouco mais baixos e esteja apenas procurando absorver
  parte desse gênio lendo publicações famosas em seu idioma nativo.`,
} as ILanguage;
